export default __webpack_public_path__ + "static/media/RE.11d66187.svg";